import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

//Serives
import { HttpService } from '../../../app/modules/shared/services/http.service';
import { GetAllLeadGroupByRequest, GetAllLeadRequestModel, SavedFilterData } from '../model/lead-request.model';
import { GetAllLeadRequestForKanbanModel } from '../model/lead-request-kanban.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class LeadServiceN {
    baseLeadURL: string;
    mlAPI: string;

    constructor(
        private httpService: HttpService,
        private http: HttpClient,
        ) {
        this.baseLeadURL = environment.apiUrlNewLead;
        this.mlAPI = environment.mlAPI;
    }

    getStages(channelId: number, isActive: boolean, filter: string) {
        return this.httpService.getAll(`${this.baseLeadURL}v2/Lead/StageWiseCount/Channel/${channelId}?IsActive=${isActive}&filter=${filter}`);
    }

    getLeadsList(requestModel: GetAllLeadRequestModel) {
        return this.httpService.create(`${this.baseLeadURL}v2/Lead/GetPagedList`, requestModel);
    }

    getLeadListWithFilters(requestModel: GetAllLeadRequestModel){
        return this.httpService.create(`${this.baseLeadURL}v2/Lead/GetPagedListWithFilter`, requestModel);
    }

    getLeadGroupList(requestModel: GetAllLeadGroupByRequest){
        return this.httpService.create(`${this.baseLeadURL}v2/Lead/GetGroupedPagedList`, requestModel);
    }

    getLeadsListForKanban(requestModel: GetAllLeadRequestForKanbanModel) {
        return this.httpService.create(`${this.baseLeadURL}v2/Lead/GetPagedListKanban`, requestModel);
    }

    getLeadsMLAIScore(leadId: number) {
        return this.httpService.getById(`${this.mlAPI}Scoring/lead/${leadId}`);
    }

    getLeadsMLAIGrade(leadId: number) {
        return this.httpService.getById(`${this.mlAPI}Scoring/lead/${leadId}/grade`);
    }

    moveLead(accountData: any): Observable<any> {
        return this.httpService.put(`${this.baseLeadURL}v2/Lead/Move`, accountData);
    }

    getLeadPagetListByIdsWithFilter(data:any){
        return this.httpService.post(`${this.baseLeadURL}v2/Lead/GetPagedListByIdsWithFilter`,data);
    }
        
    getAllTags() {
        return this.http.get<any>(`${environment.apiUrlNew}Tag/All`);
    }

    addTags(tag) {
        return this.http.post<any>(environment.apiUrlNew + 'Tag', tag);
    }

    saveFilterDataChannalWise(data: {moduleId: number, channelId: number , filterData: SavedFilterData}){
        return this.http.post<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`, data?.filterData);
    }

    getSavedFilterDataChannalWise(data: {moduleId: number, channelId: number}){
        return this.http.get<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedFilterChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedGroupByChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetGroupBy/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }
}